var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _circle, _circle2, _circle3, _path8, _g3, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _path21, _g5, _g6, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberIron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_374_97784)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_97784)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_374_97784)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.194 23.5383C386.615 51.7683 373.736 94.5986 337.753 120.628C301.868 146.587 258.296 144.264 237.819 115.957C217.236 87.5034 227.223 41.9449 262.929 16.1151C298.637 -9.7156 345.611 -4.91448 366.194 23.5383Z",
    stroke: "url(#paint1_linear_374_97784)",
    strokeWidth: 6.46129
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.87626C389.995 44.1854 382.299 86.8792 340.851 120.517C298.174 151.985 251.879 144.394 227.546 113.444C203.213 82.4934 212.137 31.0455 249.927 3.70892C287.716 -23.6277 337.782 -22.1135 360.2 8.87626Z",
    fill: "url(#paint2_linear_374_97784)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 8.0558C366.08 22.2062 367.773 40.0091 362.241 57.7807C356.7 75.576 343.934 93.1871 325.555 106.482C288.59 133.222 244.247 131.37 223.811 103.12C203.271 74.7264 213.96 28.5691 250.745 1.95906C287.531 -24.6519 335.304 -20.337 355.843 8.0558Z",
    stroke: "#AAAEB3",
    strokeWidth: 6.46129
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 8.10005C364.519 31.5027 355.012 71.7831 319.573 97.4199C284.133 123.057 242.9 119.481 225.971 96.0783C209.042 72.6756 218.549 32.3953 253.989 6.75843C289.428 -18.8784 330.661 -15.3026 347.59 8.10005Z",
    fill: "url(#paint3_linear_374_97784)",
    stroke: "url(#paint4_linear_374_97784)",
    strokeWidth: 17.948
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.107 88.4702L254.601 61.2299L317.655 69.0684L291.107 88.4702Z",
    fill: "#C6C4C4",
    stroke: "#E5E5E5",
    strokeWidth: 0.925714
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.197 60.7696L301.212 34.6L290.531 87.4742L254.197 60.7696Z",
    fill: "#C6C4C4",
    stroke: "#E5E5E5",
    strokeWidth: 0.925714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_374_97784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    fill: "#C6C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    stroke: "#E5E5E5",
    strokeWidth: 0.925714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_374_97784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    fill: "#C6C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    stroke: "#E5E5E5",
    strokeWidth: 0.925714
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.7148L284.724 83.7799L263.932 29.585L253.341 60.7148Z",
    fill: "#C6C4C4",
    stroke: "#E5E5E5",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.7749,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.7749)",
    fill: "#C6C4C4",
    stroke: "#E5E5E5",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 69.1391,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 69.1391)",
    fill: "#C6C4C4",
    stroke: "#E5E5E5",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 30.155,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 30.155)",
    fill: "#C6C4C4",
    stroke: "#E5E5E5",
    strokeWidth: 0.462857
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.197 24.4827 347.156 37.85 342.578 51.456C338.001 65.0586 327.915 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.217 90.1421C226.929 80.0677 225.97 66.7003 230.549 53.0944C235.126 39.4917 245.211 25.775 259.773 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    stroke: "url(#paint5_linear_374_97784)",
    strokeWidth: 2.87168
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_374_97784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.728L378.34 64.547C381.61 45.3291 374.46 29.9472 371.65 25.68C369.426 21.5115 365.3 15.656 360.441 9.23124C347.545 -10.9302 320.361 -28.912 278.102 -15.4846C227.842 1.80048 211.183 42.5319 209.396 60.5175L363.49 45.7588L367.786 47.728Z",
    fill: "#FEFFFE",
    fillOpacity: 0.22
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddddd_374_97784)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_97784)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "#737475"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dddddd_374_97784)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint6_linear_374_97784)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 58.7772L29.7776 52.8262L31.7613 58.7772H27.7939Z",
    fill: "url(#paint7_linear_374_97784)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 52.8262L31.761 58.7772H34.4059L29.7773 52.8262Z",
    fill: "url(#paint8_linear_374_97784)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7284L25.1484 58.7773H27.7933L29.777 64.7284Z",
    fill: "url(#paint9_linear_374_97784)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 58.7773H27.7939L29.7776 64.7284L31.7613 58.7773Z",
    fill: "url(#paint10_linear_374_97784)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.761 58.7773H34.4059L29.7773 64.7284L31.761 58.7773Z",
    fill: "url(#paint11_linear_374_97784)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_97784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_97784",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 52,
    width: 10,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint12_linear_374_97784)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "url(#paint13_linear_374_97784)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "url(#paint14_linear_374_97784)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "url(#paint15_linear_374_97784)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint16_linear_374_97784)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint17_linear_374_97784)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_97784)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_374_97784)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7909 52.8306L27.8072 58.7816L27.7793 58.7723L29.763 52.8213L29.7909 52.8306Z",
    fill: "url(#paint18_linear_374_97784)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7637 64.7235L31.7473 58.7725L31.7752 58.7818L29.7916 64.7328L29.7637 64.7235Z",
    fill: "url(#paint19_linear_374_97784)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_97784)",
    filter: "url(#filter7_f_374_97784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_374_97784",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 52,
    width: 5,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 52.8262L27.7646 58.7258H31.7834L29.7483 52.8262Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0146939
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_374_97784)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1953,
    y: 33.9453,
    width: 0.861728,
    height: 46.9824,
    transform: "rotate(30.433 42.1953 33.9453)",
    fill: "#635F5F",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 35.8389,
    width: 1.27325,
    height: 45.5408,
    transform: "rotate(30.433 42.8672 35.8389)",
    fill: "#635F5F",
    fillOpacity: 0.2
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_374_97784)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7769,
    cy: 53.273,
    rx: 0.330612,
    ry: 0.446843,
    fill: "url(#paint20_linear_374_97784)"
  })))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0481 65.8945V54.1306H54.6642V65.8945H52.0481ZM56.6965 65.8945V57.7964H59.2459V65.8945H56.6965ZM59.2459 61.4455L58.1795 60.6124C58.3906 59.6682 58.7461 58.935 59.2459 58.4129C59.7458 57.8908 60.4401 57.6298 61.3288 57.6298C61.7176 57.6298 62.0564 57.6909 62.3452 57.813C62.6452 57.9241 62.9062 58.1019 63.1284 58.3463L61.6121 60.2625C61.501 60.1403 61.3621 60.0459 61.1955 59.9792C61.0289 59.9126 60.84 59.8792 60.629 59.8792C60.2068 59.8792 59.868 60.0125 59.6125 60.2791C59.3681 60.5346 59.2459 60.9234 59.2459 61.4455ZM67.4788 66.0778C66.6457 66.0778 65.8903 65.8945 65.2127 65.5279C64.5462 65.1503 64.0185 64.6393 63.6297 63.995C63.2409 63.3507 63.0465 62.6286 63.0465 61.8288C63.0465 61.029 63.2409 60.3125 63.6297 59.6793C64.0185 59.0461 64.5462 58.5462 65.2127 58.1796C65.8792 57.8019 66.6346 57.6131 67.4788 57.6131C68.3231 57.6131 69.0785 57.7964 69.745 58.163C70.4115 58.5295 70.9392 59.035 71.328 59.6793C71.7168 60.3125 71.9112 61.029 71.9112 61.8288C71.9112 62.6286 71.7168 63.3507 71.328 63.995C70.9392 64.6393 70.4115 65.1503 69.745 65.5279C69.0785 65.8945 68.3231 66.0778 67.4788 66.0778ZM67.4788 63.7617C67.8454 63.7617 68.1676 63.6839 68.4453 63.5284C68.723 63.3618 68.9341 63.1341 69.0785 62.8452C69.234 62.5453 69.3117 62.2065 69.3117 61.8288C69.3117 61.4511 69.234 61.1234 69.0785 60.8457C68.9229 60.5569 68.7063 60.3347 68.4286 60.1792C68.162 60.0125 67.8454 59.9292 67.4788 59.9292C67.1234 59.9292 66.8068 60.0125 66.529 60.1792C66.2513 60.3347 66.0347 60.5569 65.8792 60.8457C65.7237 61.1345 65.6459 61.4678 65.6459 61.8455C65.6459 62.212 65.7237 62.5453 65.8792 62.8452C66.0347 63.1341 66.2513 63.3618 66.529 63.5284C66.8068 63.6839 67.1234 63.7617 67.4788 63.7617ZM78.5292 65.8945V61.2789C78.5292 60.8568 78.3959 60.518 78.1293 60.2625C77.8738 59.9959 77.5461 59.8626 77.1462 59.8626C76.8684 59.8626 76.624 59.9237 76.413 60.0459C76.2019 60.157 76.0353 60.3236 75.9131 60.5458C75.7909 60.7568 75.7298 61.0012 75.7298 61.2789L74.7467 60.7957C74.7467 60.1625 74.8856 59.6071 75.1633 59.1294C75.441 58.6517 75.8242 58.2852 76.313 58.0297C76.8129 57.7631 77.3739 57.6298 77.996 57.6298C78.5958 57.6298 79.1235 57.7742 79.5789 58.063C80.0455 58.3407 80.4121 58.7128 80.6787 59.1794C80.9453 59.646 81.0786 60.157 81.0786 60.7124V65.8945H78.5292ZM73.1804 65.8945V57.7964H75.7298V65.8945H73.1804ZM86.1224 65.8945V54.1306H87.9886L92.6209 61.3456H91.6711L96.2867 54.1306H98.1696V65.8945H95.5535V58.5462L96.0201 58.6629L93.0041 63.3618H91.2712L88.2719 58.6629L88.7218 58.5462V65.8945H86.1224ZM104.192 66.0778C103.314 66.0778 102.531 65.9001 101.842 65.5446C101.164 65.178 100.631 64.6726 100.242 64.0283C99.8536 63.384 99.6592 62.6564 99.6592 61.8455C99.6592 61.0345 99.8481 60.3125 100.226 59.6793C100.615 59.035 101.137 58.5295 101.792 58.163C102.447 57.7964 103.186 57.6131 104.008 57.6131C104.808 57.6131 105.513 57.7853 106.124 58.1296C106.735 58.474 107.213 58.9517 107.557 59.5626C107.913 60.1736 108.091 60.8735 108.091 61.6622C108.091 61.8066 108.08 61.9621 108.057 62.1287C108.046 62.2842 108.018 62.4675 107.974 62.6786L100.992 62.6953V60.9457L106.891 60.929L105.791 61.6622C105.78 61.1956 105.708 60.8124 105.575 60.5124C105.441 60.2014 105.241 59.9681 104.975 59.8126C104.719 59.646 104.403 59.5626 104.025 59.5626C103.625 59.5626 103.275 59.6571 102.975 59.8459C102.686 60.0237 102.459 60.2791 102.292 60.6124C102.136 60.9457 102.059 61.3511 102.059 61.8288C102.059 62.3065 102.142 62.7175 102.309 63.0618C102.486 63.3951 102.731 63.6562 103.042 63.845C103.364 64.0227 103.742 64.1116 104.175 64.1116C104.575 64.1116 104.936 64.045 105.258 63.9117C105.58 63.7672 105.863 63.5562 106.108 63.2785L107.507 64.6781C107.108 65.1447 106.624 65.4946 106.058 65.7279C105.491 65.9612 104.869 66.0778 104.192 66.0778ZM109.321 65.8945V57.7964H111.871V65.8945H109.321ZM114.503 65.8945V61.1623C114.503 60.7513 114.376 60.4347 114.12 60.2125C113.876 59.9792 113.57 59.8626 113.204 59.8626C112.948 59.8626 112.72 59.9181 112.52 60.0292C112.321 60.1292 112.159 60.2736 112.037 60.4624C111.926 60.6513 111.871 60.8846 111.871 61.1623L110.888 60.729C110.888 60.0847 111.026 59.5349 111.304 59.0794C111.582 58.6129 111.96 58.2574 112.437 58.013C112.915 57.7575 113.454 57.6298 114.053 57.6298C114.62 57.6298 115.125 57.7575 115.57 58.013C116.025 58.2685 116.386 58.624 116.653 59.0794C116.919 59.5349 117.053 60.0792 117.053 60.7124V65.8945H114.503ZM119.686 65.8945V61.1623C119.686 60.7513 119.558 60.4347 119.302 60.2125C119.058 59.9792 118.752 59.8626 118.386 59.8626C118.13 59.8626 117.903 59.9181 117.703 60.0292C117.503 60.1292 117.342 60.2736 117.219 60.4624C117.108 60.6513 117.053 60.8846 117.053 61.1623L115.586 60.9623C115.609 60.2736 115.77 59.6848 116.07 59.1961C116.381 58.6962 116.786 58.3129 117.286 58.0463C117.797 57.7686 118.369 57.6298 119.002 57.6298C119.624 57.6298 120.174 57.7631 120.652 58.0297C121.141 58.2852 121.524 58.6573 121.802 59.1461C122.091 59.6237 122.235 60.2014 122.235 60.879V65.8945H119.686ZM128.534 66.0612C127.99 66.0612 127.49 65.9501 127.035 65.7279C126.579 65.4946 126.207 65.1891 125.918 64.8114C125.629 64.4226 125.463 63.9894 125.418 63.5117V60.0959C125.463 59.6182 125.629 59.1961 125.918 58.8295C126.207 58.4518 126.579 58.1574 127.035 57.9463C127.49 57.7353 127.99 57.6298 128.534 57.6298C129.301 57.6298 129.978 57.813 130.567 58.1796C131.167 58.5462 131.634 59.0461 131.967 59.6793C132.311 60.3125 132.483 61.0345 132.483 61.8455C132.483 62.6564 132.311 63.3784 131.967 64.0116C131.634 64.6448 131.167 65.1447 130.567 65.5113C129.978 65.8779 129.301 66.0612 128.534 66.0612ZM128.084 63.7617C128.44 63.7617 128.751 63.6784 129.017 63.5117C129.295 63.3451 129.512 63.1174 129.667 62.8286C129.823 62.5397 129.901 62.212 129.901 61.8455C129.901 61.4678 129.823 61.1345 129.667 60.8457C129.512 60.5569 129.295 60.3347 129.017 60.1792C128.751 60.0125 128.44 59.9292 128.084 59.9292C127.729 59.9292 127.412 60.0125 127.135 60.1792C126.857 60.3347 126.64 60.5569 126.485 60.8457C126.34 61.1345 126.268 61.4678 126.268 61.8455C126.268 62.2231 126.346 62.5564 126.501 62.8452C126.657 63.1341 126.868 63.3618 127.135 63.5284C127.412 63.6839 127.729 63.7617 128.084 63.7617ZM123.869 65.8945V53.7973H126.418V59.7793L126.002 61.7455L126.385 63.7117V65.8945H123.869ZM137.778 66.0778C136.9 66.0778 136.117 65.9001 135.428 65.5446C134.751 65.178 134.217 64.6726 133.829 64.0283C133.44 63.384 133.245 62.6564 133.245 61.8455C133.245 61.0345 133.434 60.3125 133.812 59.6793C134.201 59.035 134.723 58.5295 135.378 58.163C136.034 57.7964 136.772 57.6131 137.594 57.6131C138.394 57.6131 139.1 57.7853 139.71 58.1296C140.321 58.474 140.799 58.9517 141.144 59.5626C141.499 60.1736 141.677 60.8735 141.677 61.6622C141.677 61.8066 141.666 61.9621 141.643 62.1287C141.632 62.2842 141.605 62.4675 141.56 62.6786L134.578 62.6953V60.9457L140.477 60.929L139.377 61.6622C139.366 61.1956 139.294 60.8124 139.161 60.5124C139.027 60.2014 138.827 59.9681 138.561 59.8126C138.305 59.646 137.989 59.5626 137.611 59.5626C137.211 59.5626 136.861 59.6571 136.561 59.8459C136.272 60.0237 136.045 60.2791 135.878 60.6124C135.723 60.9457 135.645 61.3511 135.645 61.8288C135.645 62.3065 135.728 62.7175 135.895 63.0618C136.072 63.3951 136.317 63.6562 136.628 63.845C136.95 64.0227 137.328 64.1116 137.761 64.1116C138.161 64.1116 138.522 64.045 138.844 63.9117C139.166 63.7672 139.449 63.5562 139.694 63.2785L141.094 64.6781C140.694 65.1447 140.21 65.4946 139.644 65.7279C139.077 65.9612 138.455 66.0778 137.778 66.0778ZM142.907 65.8945V57.7964H145.457V65.8945H142.907ZM145.457 61.4455L144.39 60.6124C144.601 59.6682 144.957 58.935 145.457 58.4129C145.957 57.8908 146.651 57.6298 147.54 57.6298C147.928 57.6298 148.267 57.6909 148.556 57.813C148.856 57.9241 149.117 58.1019 149.339 58.3463L147.823 60.2625C147.712 60.1403 147.573 60.0459 147.406 59.9792C147.24 59.9126 147.051 59.8792 146.84 59.8792C146.418 59.8792 146.079 60.0125 145.823 60.2791C145.579 60.5346 145.457 60.9234 145.457 61.4455Z",
    fill: "#737475"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_374_97784",
    x: -22.3261,
    y: 0.668945,
    width: 368.652,
    height: 220.565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27.9076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.163
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0.0912224 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_374_97784",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_374_97784",
    x: 274.534,
    y: 34.6593,
    width: 23.8025,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_374_97784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_374_97784",
    x: 261.692,
    y: 40.5593,
    width: 33.8629,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_374_97784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_374_97784",
    x: 206.524,
    y: -23.0006,
    width: 175.527,
    height: 90.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43584,
    result: "effect1_foregroundBlur_374_97784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddddd_374_97784",
    x: -51.8396,
    y: 23.7547,
    width: 163.851,
    height: 163.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.973442
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_97784",
    result: "effect2_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40472
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_97784",
    result: "effect3_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85728
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_97784",
    result: "effect4_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6962
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_97784",
    result: "effect5_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.1771
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_97784",
    result: "effect6_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_97784",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dddddd_374_97784",
    x: -11.8801,
    y: 52.8262,
    width: 83.6226,
    height: 95.8338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28084
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.512338
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.0787208 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.07805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23122
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.11309 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_374_97784",
    result: "effect2_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.79569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.31828
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_374_97784",
    result: "effect3_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13541
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.16691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_374_97784",
    result: "effect4_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.3371
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.73483
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.201279 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_374_97784",
    result: "effect5_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 46.2857
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_374_97784",
    result: "effect6_dropShadow_374_97784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_374_97784",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_374_97784",
    x: 27.1915,
    y: 52.2335,
    width: 3.18723,
    height: 7.13547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.293878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_374_97784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_374_97784",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_374_97784",
    x: 27.412,
    y: 52.4735,
    width: 4.72386,
    height: 6.60472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176327,
    result: "effect1_foregroundBlur_374_97784"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_374_97784",
    x: 28.7851,
    y: 52.1649,
    width: 1.98358,
    height: 2.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330612,
    result: "effect1_foregroundBlur_374_97784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_97784",
    x1: 37.0286,
    y1: -109.052,
    x2: 289.693,
    y2: 193.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9CA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_97784",
    x1: 261.219,
    y1: 13.3647,
    x2: 340.343,
    y2: 122.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C8CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98989D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_97784",
    x1: 359.177,
    y1: 90.0005,
    x2: 264.798,
    y2: 166.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0923C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#6F747A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D3D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_374_97784",
    x1: 248.729,
    y1: -0.512577,
    x2: 324.832,
    y2: 104.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_374_97784",
    x1: 318.477,
    y1: -20.9744,
    x2: 263.751,
    y2: 125.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417119,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_374_97784",
    x1: 250.405,
    y1: 23.8115,
    x2: 317.6,
    y2: 88.5657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#CECECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_374_97784",
    x1: 29.777,
    y1: 52.8262,
    x2: 25.3616,
    y2: 58.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_374_97784",
    x1: 31.7613,
    y1: 52.8262,
    x2: 27.1784,
    y2: 58.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_374_97784",
    x1: 34.4059,
    y1: 52.8262,
    x2: 29.9905,
    y2: 58.9314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_374_97784",
    x1: 29.777,
    y1: 58.7773,
    x2: 25.3616,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_374_97784",
    x1: 31.7613,
    y1: 58.7773,
    x2: 27.1784,
    y2: 64.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_374_97784",
    x1: 34.4059,
    y1: 58.7773,
    x2: 29.9905,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_374_97784",
    x1: 34.4056,
    y1: 52.8262,
    x2: 22.3105,
    y2: 57.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_374_97784",
    x1: 25.1484,
    y1: 52.8262,
    x2: 37.2436,
    y2: 57.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_374_97784",
    x1: 29.777,
    y1: 52.8262,
    x2: 29.777,
    y2: 64.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_374_97784",
    x1: 25.1484,
    y1: 52.8262,
    x2: 33.9792,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_374_97784",
    x1: 34.4056,
    y1: 52.8262,
    x2: 25.5748,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_374_97784",
    x1: 29.777,
    y1: 58.7772,
    x2: 29.0351,
    y2: 64.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_374_97784",
    x1: 29.7769,
    y1: 52.8259,
    x2: 27.7932,
    y2: 58.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_374_97784",
    x1: 31.7752,
    y1: 58.7725,
    x2: 27.6666,
    y2: 61.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74767C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93949A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_374_97784",
    x1: 29.7769,
    y1: 52.8262,
    x2: 29.7769,
    y2: 53.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_97784"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_97784"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_97784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25714,
    height: 11.902,
    fill: "white",
    transform: "translate(25.1484 52.8262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_97784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01878,
    height: 5.89959,
    fill: "white",
    transform: "translate(27.7646 52.8262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIron);
export default __webpack_public_path__ + "static/media/member_iron.70010d784b44390297a4b13494c0cb8a.svg";
export { ForwardRef as ReactComponent };